<template>
    <div class="mx-auto w-50 rounded mt-5"  id="simcardInternt">
        <div class="d-flex justify-content-around ">
            <div class="shadow w-25 mt-3 d-flex align-items-center justify-content-center border-raduis font-charge " :class="{'on' : route.query.mode == 'charge'}" role="button"  style="height:3em" @click="setMode($event,'charge')">
                شارژ
            </div>
            <div class="shadow w-25 mt-3 d-flex align-items-center justify-content-center border-raduis font-charge" :class="{'on' : route.query.mode == 'internet'}" role="button"  style="height:3em" @click="setMode($event,'internet')">
                اینترنت
            </div>
        </div>
        <div class="mt-3">
            <div class="position-relative input-phone-box hasType">
                <label class="px-3 mt-2 text-muted">لطفا شماره همراه خودتان را وارد نمایید</label>
                <div class="form-group form-group-lg search-input" style="margin-bottom: 0;width: 100%;"> 	
                        <label v-if="card.mobile && card.mobile.length >= 11" @click="card.mobile = '' ">تغییر شماره</label>
                        <label v-else style="top: 13px" @click="card.getMobileList"><img src="https://radap.ir/imagesUploaded/other/contact.png" width="25" /></label>
                        <form autocomplete="off">
                            <input class="form-control default-input undefined w-100 text-start pr-3" name="myChargeMobile" maxlength="11" minlength="11" type="tel" dir="ltr" v-model="card.mobile" >
                        </form>
                        <ul class=" list-group search-suggestion" id="searchResultUl" v-if="card.mobileList">
                            <li class="list-group-item py-2 d-flex justify-content-between" v-for="item in card.mobileList" :key="item.id" >
                                <span @click="card.mobile = item.mobile,card.mobileList = ''">{{convertToPersian(String(item.mobile))}}</span>
                                <span @click="card.mobile = item.mobile,card.mobileList = ''">{{item.name}}</span>
                                <span @click="card.getPopupCardName(item.mobile,item.name)"><i class="bi bi-edit"></i></span>
                            </li>
                        </ul>
                    </div>
            </div>
        </div>
        <label class="px-3 mt-2 text-muted ">لطفا اپراتور خود را انتخاب نمایید</label>
        <div class="my-3 d-flex justify-content-center">
            <div class="type-item irancell irancell-operator " role="button" data-operator="MTN" data-operator-fa="ایرانسل"><img  @click="card.setOperator($event)" src="https://radap.ir/imagesUploaded/card/irancell.png"></div>
            <div class="type-item hamrahaval hamrahaval-operator " role="button" data-operator="MCI" data-operator-fa="همراه اول"><img  @click="card.setOperator($event)" src="https://radap.ir/imagesUploaded/card/hamrahaval.png"></div>
            <div class="type-item rightel rightel-operator " role="button" data-operator="RTL" data-operator-fa="رایتل"><img  @click="card.setOperator($event)" src="https://radap.ir/imagesUploaded/card/rightel.png"></div>
        </div>
        <label class="px-3 mt-2 text-muted">ایا سیم کارتتان را ترابرد کرده اید؟</label>
        <input type="radio" name="mnp" value="1"> <label class="pl-3 text-muted">بله</label>
        <input type="radio" name="mnp" checked value="2"> <label class="pl-3 text-muted">خیر</label>
        <div class="mt-3" >
            <div class="switchToggle false">
                <span class="checked irancell" role="button" data-number="credit" @click="card.setTypeSim($event)">اعتباری</span>
                <span class="irancell" role="button" data-number="permanent" @click="card.setTypeSim($event)">دائمی</span>
            </div>
        </div>
        <div class="mt-3">
            <div>
                <div class="currency-Input">
                    <select class="form-select default-input  text-start mpr-4" v-model="card.priod" >
                        <option selected disabled value="0">مدت زمان</option>
                        <option value="hourly">ساعتی</option>
                        <option value="daily">روزانه</option>
                        <option value="weekly">هفتگی</option>
                        <option value="monthly">ماهانه</option>
                        <option value="yearly">سالانه</option>
                    </select>
                </div>
            </div>
        </div>
        <button class="btn btn-info w-100 mt-3 border-raduis h-5" style="border-radius: 21px;height: 50px;font-weight: 700;font-size: 20px;" @click="getPackage">نمایش بسته ها</button>
        <card-benefit />

    </div>
    <ol class="sl my-2" style="height: 410px;overflow: auto;" v-if="validPackages.length > 0">
                <li class="c1" v-for="item,index in validPackages" :key="index">
                    <div class="c1d" :data-id="item.id">
                        <dl><dt>عنوان</dt>
                            <dd class="t">{{ item.name }}</dd>
                            <dt>نوع سیمکارت</dt>
                            <dd class="stmc">
                                <div class="stl">
                                    <label class="title">{{simType(item.sim_type)}}</label>
                                </div>
                            </dd><dt>مدت اعتبار</dt>
                            <dd class="di">
                                <div class="dl">
                                    <label class="title">{{sim_time(item.internet_type)}}</label>
                                </div>
                            </dd><dt>مبلغ</dt>
                            <dd class="p"><b>{{convertToPersian(String(numberFormat(item.amount)))}} تومان</b></dd><dt>مبلغ قابل پرداخت</dt>
                        </dl>
                    </div>
                    <button class="bu border-0 "  :title="'خرید بسته '+item.name" @click="card.setFactor($event)" :data-amount="item.amount" :data-id="item.id" :data-priod="item.internet_type" :data-name="item.name">خرید آنلاین</button>
                </li> 
    </ol>
    <div class="my-3 text-center" v-if="validPackages.length < 1 && submitFlag == true">هیچ بسته ای یافت نشد</div> 
    <card-modal />
    <card-name  />
</template>

<script setup>
import cardModal from '../../popup/CardTemp.vue'
import CardName from '../../popup/CardName.vue'
import CardBenefit from '../../popup/CardBenefit.vue'
import axios from 'axios';
import { reactive,watch,computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { alertBox } from '@/composables/silverBox' 
import { convertToPersian, numberFormat } from '@/composables/digits' 
import { useCard } from '@/store/card'
let card = useCard()
card.reset()
let router = useRouter()
let route = useRoute()


watch(card, () => {
    if(card.mobile){
        card.mobile = convertToPersian(String(card.mobile))
    }
    card.amount = convertToPersian(String(card.amount))
});

card.type = 'credit'
card.mode = 'internet'
card.modeFa = 'بسته اینترنت'
let packages = ref()
let submitFlag = ref(false)
let validPackages = ref([])

function simType(type){
    if(type == 'credit'){
        return 'سیم کارت اعتباری'
    }else if(type == 'permanent '){
        return 'سیم کارت دائمی'
    }else{
        return 'TDLTE'
    }
}
function sim_time(type){
    if(type == 'hourly'){
        return 'ساعتی'
    }else if(type == 'daily'){
        return 'روزانه'
    }else if(type == 'weekly'){
        return 'هفتگی'
    }else if(type == 'monthly'){
        return 'ماهیانه'
    }else if(type == 'yearly'){
        return 'سالیانه'
    }else if(type == 'amazing'){
        return 'شگفت انگیز'
    }else{
        return 'TDLTE'
    }
}
function getPackage()
{
    if(!document.querySelector('.active')){
          alertBox("لطفا اپراتور را انتخاب کنید")
    }else{
          validPackages.value = []
          submitFlag.value = true
          axios.get('https://radap.ir/Backend/api/section/card/packeges.php')
          .then(res =>{
                packages.value = res.data.products.internet
                card.operator = document.querySelector('.active').getAttribute('data-operator');
                packages.value.map(verification)
            })
    }
}
function verification(item){
    if(item.operator == card.operator && item.sim_type == card.type && item.internet_type == card.priod && item.name.search('انارستان') < 1){
        validPackages.value.push(item)
    }
}
function setMode(e,mode){
  document.querySelector('.on').classList.remove('on')
  e.target.classList.add('on')
  router.push({name:"Simcard",query:{mode:mode}})
}
</script>

<style scoped>
@media (max-width: 414px)
{
    .sl {
        max-width: 100%;
        margin: auto;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
    }
}
.sl {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
}
@media (max-width: 414px)
{

    .sl .c1 {
        margin: 5px 0;
        width: 92%;
    }
}

@media (max-width: 414px)
{
    .c1d {
        width: 100%;
    }
}
.c1d, .no {
    width: -webkit-fill-available;
}
.c1 button, .no {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.c1d dt, header .cls, header .cls span, header .tog, header .tog span {
    display: none;
}
@media (max-width: 414px)
{

    .c1d .stmc .stl .title {
        font-size: 12px;
    }
}
.c1d .di .title, .c1d .stmc .stl .title {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #1d2939;
    background: #f2f4f7;
    border-radius: 16px;
    padding: 2px 8px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    gap: 5px;
    cursor: pointer;
}

@media (max-width: 414px)
{

    .c1d .t {
        margin: 2px 5px 10px 5px;
        font-size: 14px;
        padding-bottom: 5px;
    }
}

.c1d .t {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    color: #1d2939;
    grid-column: span 2;
    margin-bottom: 12px;
}

@media (max-width: 414px)
{
    .c1d dl {
    margin-bottom: 0;
}
}
.c1d dl {
    margin: 0;
    padding: 0;
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
}

.c1 button {
    background-color: #ffbe00;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-decoration: none;
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    color: #000000;
    border-radius: 8px;
    position: absolute;
    left: 12px;
    bottom: 12px;
    width: 94px;
    height: 32px;
}
.c1, .c1 button {
    border-radius: 3px;
    -webkit-transition: 0.7s;
    transition: 0.7s;
}

.c1 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    list-style: none;
    border-top: 3px solid #fff;
    margin: 15px;
    width: 255px;
    background: #ffffff;
    -webkit-box-shadow: 0px 8px 16px #eff0f6;
    box-shadow: 0px 8px 16px #eff0f6;
    border-radius: 8px;
    padding: 12px;
    position: relative;
}
.c1, .c1 button {
    border-radius: 3px;
    -webkit-transition: 0.7s;
    transition: 0.7s;
}

.font-charge{
    font-weight: 900;
    font-size: 18px;
    line-height: 28px;
    font-style: normal;
    font-weight: 900;
    line-height: 40px;
    color: #2b3674;
}
.border-raduis{
    border-radius: 30px;
}
label {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    text-align: right;
    margin-bottom: 10px;
}
.default-input {
    border: 1px solid #bebebe;
    box-sizing: border-box;
    border-radius: 21px !important;
    height: 50px;
    font-weight: 700;
    font-size: 20px;
}
.type-item img {
    width: 64px;
    height: 64px;
    mix-blend-mode: luminosity;
    opacity: .4;
}
.type-item{
    width: 30%;
    text-align: center;
}
.active img{
    mix-blend-mode: normal;
    opacity: 1;
}
.switchToggle {
    height: 50px;
    background: #fff;
    border: 1px solid #bebebe;
    border-radius: 21px;
    display: flex;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
}
.switchToggle span.irancell.checked {
    background-color: #fff2c2;
    /* border: 1px solid #ffcb08; */
}
.switchToggle span {
    width: 50%;
    border-radius: 21px;
    padding-top: 10px;
    cursor: pointer!important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.w-18{
width: 18%;
}
.btn-price span,.btn-price small{
    font-weight: 700;
    font-size: 15px;
    color: black;
}
.h-5{
    height: 5em;
}
.buttons-template{
    margin-bottom: 5px;
}
.on{
    background-color: #cfc9c9;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
@media (max-width: 772px) {
  #simcardInternt {
    width: 100% !important;
    padding: 1em !important;
  }
}
.mpr-4{
    padding-right: 1.5em;
}
.search-suggestion{
    max-height: 179px;
    overflow: auto;
    position: absolute;
    width: 90%;
    z-index: 2;
    top: 54px;
  }
</style>